import React, { useContext, useEffect, useState } from "react";
import "./Cart.css";
import { cartContext } from "../../context/Car/CarContext";
import Swal from "sweetalert2";
import { packageContext } from "../../context/PackageContext/PackageContext";
import { StoreContext } from "../../context/StoreContext/StoreContext";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Cart() {
  // let {counter, setcounter}=useContext(StoreContext)
    let navigate = useNavigate();
  

  let [cartData, setcartData] = useState(null);
  let { getCartData, removeItem, UpdateProductQuantity } =
    useContext(cartContext);
  let { removePackage, UpdatePackageQuantity } = useContext(packageContext);
  useEffect(() => {
    getAllData();
  }, []);

  async function Deleteitem(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let { data } = await removeItem(id);
        console.log(data);
        if (data.message === "Item(s) removed from cart successfully.") {
          Swal.fire({
            icon: "success",
            text: "Item removed from cart successfully.",
            confirmButtonText: "OK",
          });
          setcartData(data);
          getAllData();
        }

        console.log(id);
      }
    });
  }

  async function DeleteDataPackage(pckid) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let { data } = await removePackage(pckid);
        console.log(data);
        if (data.message === "Item(s) removed from cart successfully.") {
          Swal.fire({
            icon: "success",
            text: "Item removed from cart successfully.",
            confirmButtonText: "OK",
          });
          setcartData(data);
          getAllData();
        }
      }
    });
  }

  async function updateCount(id, count) {
    let { data } = await UpdateProductQuantity(id, count);
    console.log(data);
    // setcartData(data);
    getAllData();
  }

  async function updatePackageCount(pcckId, count) {
    let { data } = await UpdatePackageQuantity(pcckId, count);
    console.log(data);
    getAllData();
  }

  async function getAllData() {
    try {
      let { data } = await getCartData();
      if (data.cart.items.length > 0) {
        setcartData(data.cart);
      } else {
        setcartData({ items: [] });
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn("Cart is empty or not found.");
        setcartData({ items: [], totalPrice: 0 });
      } else {
        console.error("An unexpected error occurred:", error);
      }
    }
  }

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <>
                                          <Helmet>
                      <title>Carts</title>
                    </Helmet>
      {cartData?.items?.length > 0 ? (
        <div className=" w-75 my-3 mx-auto p-3 bg-main-light">
          <h3 className="fw-700 heading">
            Your Cart{" "}
            <span className="main-color">
              ({cartData?.items?.length} items)
            </span>{" "}
          </h3>
          <h4 className="fs-4 mb-4">
            Total Cart Price : {cartData?.totalPrice} SAR
          </h4>
          <hr />
          <div className="row">
            {cartData?.items?.map((product, index) => {
              return (
                <>
                  <div
                    className="row d-flex gap-3 align-items-center mb-3"
                    key={index}
                  >
                    <div className="col-md-2">
                      <img
                        src={
                          product.productId?.image[0]?.secure_url ||
                          product.packageId?.logo?.url
                        }
                        className="w-100"
                        alt=""
                      />
                    </div>
                    <div className="col-md-9">
                      <div className="CartDetails d-flex justify-content-between align-items-center flex-wrap">
                        <div>
                          <h3 className="text-black fs-5 p-0 mb-2">
                            {product.productId?.name || product.packageId?.name}
                          </h3>
                          <h6 className="m-0 fs-5">
                            Price :{" "}
                            <span className="main-color">
                              {product.productId?.price ||
                                product.packageId?.price}{" "}
                              SAR
                            </span>
                          </h6>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <button
                            onClick={() => {
                              product.productId
                                ? updateCount(
                                    product.productId._id,
                                    product.quantity + 1
                                  )
                                : updatePackageCount(
                                    product.packageId?._id,
                                    product.quantity + 1
                                  );
                              // setcounter(counter+1);
                            }}
                            className="btn btn-danger fw-bold fs-5 px-2  py-0 "
                          >
                            +
                          </button>
                          <span className="mx-2 px-2 fs-5">
                            {product?.quantity}
                          </span>
                          <button
                            disabled={product.quantity === 1}
                            onClick={() => {
                              product.productId
                                ? updateCount(
                                    product.productId._id,
                                    product.quantity - 1
                                  )
                                : updatePackageCount(
                                    product.packageId?._id,
                                    product.quantity - 1
                                  );
                              // setcounter(counter-1);
                            }}
                            className="btn btn-danger fw-bold fs-5 px-2  py-0"
                          >
                            -
                          </button>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          product.productId
                            ? Deleteitem(product.productId._id)
                            : DeleteDataPackage(product.packageId?._id);

                          // {product.productId? setcounter(counter-product.quantity) : setcounter(counter-1)};
                        }}
                        className="btn btn-danger"
                      >
                        <i className="font-sm fas fa-trash-can me-2"></i>
                        Remove
                      </button>
                    </div>
                    <hr />
                  </div>
                  {/* ============================================================================================ */}
                </>
              );
            })}
          </div>
          <button className="btn btn-success m-auto" onClick={()=>navigate('/payment')}>Order Now</button>
        </div>
      ) : (
        <div className="text-center my-5">
          <h3 className="main-color">Your cart is empty!</h3>
          <p>Add some items to your cart to see them here.</p>
        </div>
      )}
    </>
  );
}
